import React from "react";
import analytics from "../../images/Assets/data-analysis.png";
import connected from "../../images/Assets/connected.png";
import paper from "../../images/Assets/paper.png";

export default function Features() {
  return (
    <div className="bg-[#FBFAFE] md:px-6 xl:px-10 px-28 pt-[84px] pb-20">
      <div className="flex items-center justify-center">
        <div className="bg-[#F4F2FE] text-[14px] text-[#5B2ED9] font-gilroySemibold uppercase w-fit py-0.5 px-2.5 rounded-full">
          Features
        </div>
      </div>

      <div className="md:text-[28px] text-[40px] text-center text-[#0E062A] font-gilroySemibold mt-1">
        <span className="gradient-text">Optimizing</span> Interaction with Data
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 grid-cols-3 gap-5 mt-8">
        <div className="bg-[#F4F0FF] border border-[#F1ECFF] text-start px-5 py-8 rounded-2xl">
          <img src={analytics} alt="analytics" className="w-[40px] h-[40px]" />

          <div className="lg:text-[22px] text-[24px] text-[#0E062A] font-gilroySemibold mt-3">
            Result Set Analysis
          </div>

          <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Komodo AI enables direct analysis of results or integration with other apps via APIs.
          </div>
        </div>
        <div className="bg-[#F4F0FF] border border-[#F1ECFF] text-start px-5 py-8 rounded-2xl">
          <img src={connected} alt="connected" className="w-[40px] h-[40px]" />

          <div className="lg:text-[22px] text-[24px] text-[#0E062A] font-gilroySemibold mt-3">
            Content Ingestion
          </div>

          <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Komodo AI utilizes a broad spectrum of data connectors to access and ingest content from various
            sources.
          </div>
        </div>
        <div className="bg-[#F4F0FF] border border-[#F1ECFF] text-start px-5 py-8 rounded-2xl">
          <img src={analytics} alt="analytics" className="w-[40px] h-[40px]" />

          <div className="lg:text-[22px] text-[24px] text-[#0E062A] font-gilroySemibold mt-3">
            Deployment Options
          </div>

          <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Customers can choose to install the platform on-premises, or in a private or public cloud
            environment.
          </div>
        </div>
        <div className="bg-[#F4F0FF] border border-[#F1ECFF] text-start px-5 py-8 rounded-2xl">
          <img src={paper} alt="paper" className="w-[40px] h-[40px]" />

          <div className="lg:text-[22px] text-[24px] text-[#0E062A] font-gilroySemibold mt-3">
            Results Delivery
          </div>

          <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Main interactions with results occur through standalone and embedded dashboards where users
            visualize and examine data.
          </div>
        </div>
        <div className="bg-[#F4F0FF] border border-[#F1ECFF] text-start px-5 py-8 rounded-2xl">
          <img src={connected} alt="connected" className="w-[40px] h-[40px]" />

          <div className="lg:text-[22px] text-[24px] text-[#0E062A] font-gilroySemibold mt-3">
            Relevance Assessment and Adjustment
          </div>

          <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Komodo AI offers diverse options for testing and optimizing search relevance.
          </div>
        </div>
        <div className="bg-[#F4F0FF] border border-[#F1ECFF] text-start px-5 py-8 rounded-2xl">
          <img src={paper} alt="paper" className="w-[40px] h-[40px]" />

          <div className="lg:text-[22px] text-[24px] text-[#0E062A] font-gilroySemibold mt-3">
            Data Extraction and Enhancement
          </div>

          <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Data is initially modeled and enriched during its progression through the Pipeline.
          </div>
        </div>
      </div>
    </div>
  );
}
